import type {BaseFlagProps, ColorSchemeType} from 'platform/components';

interface EntityTagFlagSource {
  valueColor: string;
  valueName: string;
}

const COLOR_SCHEMES: readonly ColorSchemeType[] = [
  'black',
  'neutral',
  'blue',
  'teal',
  'green',
  'orange',
  'yellow',
  'magenta',
  'purple',
  'red',
];

export const getEntityTagFlagProps = (tag: EntityTagFlagSource): BaseFlagProps => {
  const [rawColor, variant] = tag.valueColor.split('.');

  return {
    label: tag.valueName,
    colorScheme: COLOR_SCHEMES.find((color) => color === rawColor) ?? 'neutral',
    isSubtle: variant === 'subtle',
  };
};
